import React, {useEffect, useState} from 'react'
import api from "../../api";
import {Button, Col, Drawer, Form, Input, Row, Switch} from "antd";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";

export default function AdminQuestions() {

    const [openQuestions, setOpenQuestions] = useState([])
    const [answerModalOpen, setAnswerModalOpen] = useState(false)
    const [hideAnsweredQuestions, setHideAnsweredQuestions] = useState(true)
    const [questionToAnswer, setQuestionToAnswer] = useState(null)
    const [questionThread, setQuestionThread] = useState([])
    const [form] = Form.useForm()

    useEffect(() => {
        api.getAllQuestions().then(setOpenQuestions)
    }, []);

    function textToLines(text) {
        if (!text) return null
        return text.split("\n").map((line, index) => (
            <span key={index}>{line}<br/></span>
        ))
    }

    return (
        <>
            <h1>Open vragen</h1>

            <Form.Item>
                <Switch defaultChecked={hideAnsweredQuestions} onChange={(e) => setHideAnsweredQuestions(e)}></Switch> Gesloten vragen verbergen
            </Form.Item>

            <Drawer width={"80%"} open={answerModalOpen} onClose={() => {
                setAnswerModalOpen(false)
                form.resetFields()
                setQuestionToAnswer(null)
            }}>
                <Form form={form} layout={"vertical"}>
                    <Form.Item name={"answer"} label={"Answer"}>
                        <TextArea rows={4}/>
                    </Form.Item>
                    <Form.Item name={"loom_video"} label={"Loom URL"}>
                        <Input/>
                    </Form.Item>
                    <Form.Item>
                        <Row>
                            <Col span={12}>

                                <Button danger={true} type={"default"} variant={"dashed"} onClick={() => {
                                    api.markQuestionAsAnswered(questionToAnswer.id).then(() => {
                                        api.getAllQuestions().then(setOpenQuestions)
                                        setQuestionToAnswer(null)
                                        setAnswerModalOpen(false)
                                        form.resetFields()
                                    })
                                }}>Mark as answered</Button>
                            </Col>

                            <Col span={12} className={"text-right"}>
                                <Button type={"primary"} onClick={() => {
                                    api.answerQuestion(
                                        questionToAnswer.id,
                                        form.getFieldValue('answer'),
                                        form.getFieldValue('loom_video')
                                    ).then(() => {
                                        api.getAllQuestions().then(setOpenQuestions)
                                        setQuestionToAnswer(null)
                                        setAnswerModalOpen(false)
                                        form.resetFields()
                                    })
                                }}>Answer</Button>
                            </Col>

                        </Row>
                    </Form.Item>
                </Form>


                {questionToAnswer && (
                    <>
                        <h1>{questionToAnswer?.user?.name} - {questionToAnswer?.user?.email}</h1>
                        {questionThread.reverse().map((q) => {
                            return (
                                <div key={q.id}>
                                    {q.answer ? (
                                        <p className={"text-right"} style={{
                                            border: 'solid 1px silver',
                                            borderRadius: '5px',
                                            lineHeight: '1.5',
                                            padding: '15px',
                                            background: 'white'
                                        }}><b>Stef</b>: {textToLines(q.answer)}</p>
                                    ) : null}
                                    <div style={{
                                        border: 'solid 1px silver',
                                        borderRadius: '5px',
                                        lineHeight: '1.5',
                                        padding: '15px',
                                        background: 'white'
                                    }}>
                                        {textToLines(q.question)}
                                        <div className={"text-right"}>
                                        <i>{dayjs(q.created_at).isValid() ? dayjs(q.created_at).fromNow() : q.created_at}</i>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </>
                )}

            </Drawer>

            {openQuestions.filter((q) => q.is_answered !== hideAnsweredQuestions).map((q) => (
                <Row key={q.id} style={{borderTop: 'solid 1px black', padding: "8px  0"}}>
                    <Col span={20}>
                        <h3>{q.user.name} @ {dayjs(q.created_at).isValid() ? dayjs(q.created_at).fromNow() : q.created_at}</h3>
                        <p>{textToLines(q.question)}</p>
                    </Col>
                    <Col span={4} className={"text-right"}>
                        <Button size={"small"} type={"default"}
                                href={`/admin/impersonate/${q.user_id}`}>Impersonate</Button>
                        <Button className={"mar-l-1"} size={"small"} type={"primary"} onClick={() => {
                            setAnswerModalOpen(true)
                            setQuestionToAnswer(q)
                            api.getQuestionThread(q.user_id).then(setQuestionThread)
                        }}>Answer</Button>
                    </Col>
                </Row>
            ))}
        </>
    )
}